import { render, staticRenderFns } from "./LabelModal3a0.vue?vue&type=template&id=e25584d6&scoped=true&"
import script from "./LabelModal3a0.vue?vue&type=script&lang=js&"
export * from "./LabelModal3a0.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal3a0.vue?vue&type=style&index=0&id=e25584d6&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal3a0.vue?vue&type=style&index=1&id=e25584d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25584d6",
  null
  
)

export default component.exports